import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import ConsultationModal from '../components/ConsultationModal';

const ContactModalContext = createContext(null);

export function ContactModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState('demo');
  const [prefill, setPrefill] = useState(null);

  const openContactModal = useCallback((type = 'demo', prefillData = null) => {
    setModalType(type || 'demo');
    setPrefill(prefillData);
    setOpen(true);
  }, []);

  const closeContactModal = useCallback(() => {
    setOpen(false);
    setPrefill(null);
  }, []);

  const value = useMemo(
    () => ({ openContactModal, closeContactModal }),
    [openContactModal, closeContactModal]
  );

  return (
    <ContactModalContext.Provider value={value}>
      {children}
      <ConsultationModal
        isOpen={open}
        onClose={closeContactModal}
        modalType={modalType}
        prefill={prefill}
      />
    </ContactModalContext.Provider>
  );
}

export function useContactModal() {
  const ctx = useContext(ContactModalContext);
  if (!ctx) {
    throw new Error('useContactModal must be used within ContactModalProvider');
  }
  return ctx;
}
